let YourDetailsView = Backbone.View.extend
(
    {
        el: $('.section-details'),

        inputFirstName: $('#firstname'),
        inputLastName: $('#lastname'),
        inputEmail: $('#email'),
        agreeTcs: $('#agreeTcs'),

        btnNext: $('.section-details').find('.btn-next')
    }
);
